<template>
  <section>
    <h2>Step 2 / 3</h2>
    <h3 class="card-title text-primary mb-4">
      {{ $t("lang.onBoarding.what_are_your_targets") }}
    </h3>
    <div
      v-if="
        onBoarding.substep == 1 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <div class="card-body text-center">
        <div class="row bg-light mx-2 pt-2 pb-2 mb-4">
          <div class="col-1">
            <img id="f1" src="@/assets/images/oliver.png" />
          </div>
          <div class="col-11">
            <b class="font-weight-bold">
              Oliver{{ $t("lang.onBoarding.tips") }}
            </b>
            {{ $t("lang.onBoarding.step2_1_tip") }}
          </div>
        </div>
        <h6 class="text-center mb-4">
          {{ $t("lang.onBoarding.step2_1_hint") }}
        </h6>
        <h5 class="mb-4">{{ $t("lang.onBoarding.step2_1_question") }}</h5>
        <!-- <IndustrySearch
          :option_list="
            optionsList.all.categories_search_level.data
          "
          :default_values="onBoarding.target.positions"
          :key="1"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch> -->
       <KeyWordSearch
        :isDisabled="isDisable"
        ref="jobtilte"
        :default_values="onBoarding.target.categories_jobs"
        @change="changeKeywords($event)"
      />
      </div>
    </div>
    <!-- <div v-if="onBoarding.substep == 2 && completeLoadingTarget && !loadingOnBoarding">
      <div class="card-body text-center">
        <h6 class="text-center mb-4">(2/5)</h6>
        <h5 class="mb-4">{{ $t("lang.onBoarding.step2_2_question") }}</h5>
        <IndustrySearch
          :option_list="
            optionsList.all.categories_search_function.data
          "
          :default_values="onBoarding.target.departments"
          :key="2"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
      </div>
    </div> -->

    <div
      v-if="
        onBoarding.substep == 2 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <div class="card-body text-center">
        <h6 class="text-center mb-4">(2/4)</h6>
        <h5 class="mb-4">{{ $t("lang.onBoarding.step2_3_question") }}</h5>
        <IndustrySearch
          :option_list="select_list_sizes"
          :default_values="onBoarding.target.sizes"
          :key="3"
          @closed="setEmployersSize($event)"
          @selected="onSelectedEmployes($event)"
          @deleted="onSelectedEmployes($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
      </div>
    </div>

    <div
      v-if="
        onBoarding.substep == 3 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <div class="card-body">
        <div class="row bg-light mx-2 pt-2 pb-2 mb-4">
          <div class="col-1">
            <img id="f1" src="@/assets/images/oliver.png" />
          </div>
          <div class="col-11">
            <b class="font-weight-bold">
              Oliver{{ $t("lang.onBoarding.tips") }}
            </b>
            {{ $t("lang.onBoarding.step2_4_tip") }}
          </div>
        </div>
        <h6 class="text-center mb-4">(3/4)</h6>
        <h5 class="text-center mb-4">
          {{ $t("lang.onBoarding.step2_4_question") }}
        </h5>
        <h6 class="text-center">{{ $t("lang.onBoarding.include") }}</h6>
        <IndustrySearch
          class="mb-4"
          :option_list="optionsList.all.categories_google_all.data"
          :default_values="onBoarding.target.sectors_include"
          :key="4"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
        <h6 class="text-center">{{ $t("lang.onBoarding.exclude") }}</h6>
        <IndustrySearch
          :option_list="optionsList.all.categories_google_all.data"
          :default_values="onBoarding.target.sectors_exclude"
          :key="5"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
      </div>
    </div>

    <div
      v-if="
        onBoarding.substep == 4 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <div class="card-body">
        <h6 class="text-center mb-4">(4/4)</h6>
        <h5 class="text-center mb-4">
          {{ $t("lang.onBoarding.step2_5_question_1") }}
        </h5>
        <IndustrySearch
          class="mb-4"
          :option_list="optionsList.all['countries'].data"
          :default_values="onBoarding.target.contact_country"
          :key="6"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
        <h5 class="text-center mb-4">
          {{ $t("lang.onBoarding.step2_5_question_2") }}
        </h5>
        <IndustrySearch
          :option_list="optionsList.all['regions'].data"
          :default_values="onBoarding.target.company_location"
          :key="7"
          @closed="loadApollo($event)"
          @selected="onSelected($event)"
          @deleted="onSelected($event), (addSelect = true)"
          :isDisabled="isDisable"
        >
        </IndustrySearch>
      </div>
    </div>

    <div
      v-if="
        onBoarding.substep == 5 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <div class="card-body text-center">
        <h3 class="pt-2 pb-2 mt-4">
          {{ $t("lang.onBoarding.excellent") }}
        </h3>
        <h6 class="text-primary">{{ $t("lang.onBoarding.lets_move_on") }}</h6>
      </div>
    </div>

    <div
      v-if="
        onBoarding.substep == 6 && completeLoadingTarget && !loadingOnBoarding
      "
    >
      <Modal :name="'step6'">
        <div class="p-4 text-left">
          <h3 class="card-title text-primary mb-2">
            {{ $t("lang.onBoarding.target_modal_title") }}
          </h3>
          <p class="text-secondary mb-3">
            {{ $t("lang.onBoarding.target_modal_description") }}
          </p>

          <div class="row">
            <div class="col-md-5">
              <div class="card">
                <div class="card-body">
                  <h4 class="mb-4">
                    {{ $t("lang.onBoarding.summary_step2_title") }}
                  </h4>
                  <Step2Summary @change="refreshTarget($event)" :selectDisable="false"  />
                  <div class="row justify-content-center">
                    <button
                      class="
                        btn btn-secondary
                        large
                        cursor-pointer
                        font-weight-bolder
                        mt-4
                        mr-2
                      "
                      type="button"
                      @click="closeModal(6)"
                    >
                      {{ $t("lang.button.back") }}
                    </button>
                    <button
                      class="
                        btn
                        large
                        cursor-pointer
                        font-weight-bolder
                        btn-primary
                        mt-4
                      "
                      type="button"
                    >
                      {{ $t("lang.button.update") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <TargetsModal :key="1231546456" :contacts="apolloResult" />
            </div>
          </div>
        </div>
      </Modal>
      <div class="card-body">
        <Step2Summary :selectDisable="false"  />
        <div class="text-center mt-4">
          <a class="text-primary mt-5" type="button" @click="showModal(6)"
            ><i class="icon-arrow-right"></i>
            {{ $t("lang.onBoarding.see_prospects_corresponding_your_targets") }}
          </a>
        </div>
      </div>
    </div>

    <div class="text-center mt-4" v-if="(onBoarding.substep == 5)">
      <a class="text-primary" type="button" @click="goToSubStep(6, false)"
        ><i class="icon-arrow-right"></i>
        {{ $t("lang.onBoarding.i_want_a_summary") }}
      </a>
    </div>
  </section>
</template>

<script>
import TargetsModal from "@/components/Onboarding/TargetsModal.vue";
import { targetsService } from "@/_services";
import Step2Summary from "@/components/Onboarding/MultiSteps/Step2Summary.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/Common/Modal.vue";

export default {
  computed: {
    ...mapState({
      optionsList: (state) => state.optionsList,
      completeLoadingTarget: (state) => state.optionsList.completeLoadingTarget,
      onBoarding: (state) => state.onboarding,
      loadingOnBoarding: (state) => state.onboarding.loading,
      isDisable: (state) => state.onboarding.isDisable,
    }),
  },
  data() {
    return {
      size: {
        greater: 0,
        less: 0,
      },
      addSelect: false,
      apolloResult: {},
      apollo: {
        people: [],
        total_result: 0,
      },
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" },
      ],
      selected_sizes: [],
    };
  },

  components: {
    IndustrySearch,
    TargetsModal,
    Step2Summary,
    Modal,
    KeyWordSearch,
  },
  mounted() {
    if (!this.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.addSelect = true;
  },

  methods: {
    ...mapActions("onboarding", {
      getApollo: "getApollo",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      updateSizeCompany: "updateSizeCompany",
      saveOrder: "save",
      updateCategoryJobs:"updateCategoryJobs"
    }),

    goToSubStep(subStep, nextStep = true) {
      this.saveOrder();
      if (subStep > 6 && nextStep) {
        this.setStep(3);
        this.setSubStep(1);
      }
      this.setSubStep(subStep);
    },
    showModal(step) {
      this.$modal.show("step" + step);
    },
    closeModal(step) {
      this.$modal.hide("step" + step);
      this.request = false;
    },
    refreshTarget(result) {
      this.apolloResult = result;
    },

    onSelected(data) {
      if (data) {
        this.addSelect = true;
      }
    },
    onSelectedEmployes(data) {
      if (data.id || data.label == "1-10") {
        this.addSelect = true;
      }
    },

     changeKeywords(e){
      this.updateCategoryJobs(e)
      this.getApollo()
    },

    // setEmployersSize(data) {
    //   this.size = this.select_list_sizes[data.id].label.split("-");

    //   this.updateSizeCompany(data.id);
    // },

    setEmployersSize(data) {
      if (this.addSelect) {
        if (data) {
          this.isDisable = true;
          this.selected_sizes = data;
          this.fillKeywordsSizes();
          this.loadApollo();
        }
      }
    },

    removeEmployersSize(data) {
      this.addSelect = true;
      this.isDisable = true;
      let index = this.selected_sizes.indexOf(data.id);
      this.selected_sizes.splice(index, 1);
      this.fillKeywordsSizes();
      this.loadApollo();
    },
    fillKeywordsSizes() {
      let greater = 0;
      let less = 0;
      this.selected_sizes.sort();

      this.selected_sizes.forEach((value, index) => {
        let keywords = this.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      this.size.greater = greater;
      this.size.less = less;
    },

    loadApollo() {
      if (this.addSelect) {
        this.getApollo();
      }
    },
  },
};
</script>
